module.exports = __webpack_public_path__ + "img/logo.352e66cc.png";